import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Native <select> styled like Input. Pass `options` as [{ value, label }]
 * (or strings), or children <option>s. `placeholder` adds an empty first
 * option so a blank value doesn't silently show the first choice.
 */
const Select = React.forwardRef(function Select(
  { className, options, placeholder, size = "md", children, ...props },
  ref
) {
  return (
    <select
      ref={ref}
      className={cn(
        "flex w-full rounded-lg border border-input bg-card text-foreground shadow-sm transition-colors",
        size === "sm" ? "h-9 px-3 text-sm" : "h-11 px-4 text-base",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    >
      {placeholder !== undefined && <option value="">{placeholder}</option>}
      {options
        ? options.map((option) => {
            const { value, label } = typeof option === "string" ? { value: option, label: option } : option;
            return <option key={value} value={value}>{label}</option>;
          })
        : children}
    </select>
  );
});

export { Select };
